import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { DpTableComponent } from '../../common-component/dp-table/dp-table.component';
import { WishlistService } from '../../services/raintree/Transmission/wishlist.service';
import { SerialNoCellComponent } from '../../table-cell/serial-no-cell.component';
import { ReachUserWishlistRes } from '../../services/raintree/interfaces/wishlist.interface';
import { ImageCellComponent } from '../../table-cell/img-cell.component';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';

@Component({
  selector: 'reach-user-wishlist-dialog',
  standalone: true,
  templateUrl: './reach-user-wishlist-dialog.component.html',
  styleUrl: './reach-user-wishlist-dialog.component.scss',
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    DpTableComponent,
    ImageCellComponent,
    LoaderComponent,
  ],
})
export class ReachUserWishlistDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _wishlistService: WishlistService,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private _dialogRef: MatDialogRef<ReachUserWishlistDialogComponent>
  ) {}
  reachUserWishlists: any = [];

  public displayColumnData: any = [
    {
      id: 'mem_key',
      name: 'Serial Number',
    },
    {
      id: 'familyCode',
      name: 'Family Code',
    },
    {
      id: 'name',
      name: 'Dikshyarthi Name',
    },
    {
      id: 'ritwikName',
      name: 'Ritwick Name',
    },
    {
      id: 'guardianName',
      name: 'Ritwick Name',
    },
    {
      id: 'contactNo',
      name: 'Contact',
    },
    {
      id: 'address',
      name: 'Address',
    },
    {
      id: 'pincode',
      name: 'Pincode',
    },
    {
      id: 'image',
      name: '',
    },
  ];
  columnConfs = {
    image: { cssClass: 'img-wid' },
  };
  cellComponentMap = {
    serialNo: SerialNoCellComponent,
    image: ImageCellComponent,
  };
  isLoading: boolean = false;
  ngOnInit(): void {
    this.fetchReacWishlistData();
  }
  deleteEntireWishlist() {
    if (this.data.wishlist.type === 'centralizedReach') {
      this._wishlistService
        .deleteReachWishList(this.data.wishlist.id)
        .subscribe({
          next: (response: any) => {
            if (!response.error) {
              this._dialogRef.close();
              const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
                panelClass: 'common-pannel-dialog-container',
                data: {
                  mainHeading: `Deleted Data '${this.data.wishlist.name} sucessfully`,
                  subHeading: `Check existing wishlists in My Wishlist page`,
                  buttonValue: 'Finish',
                },
              });
            }
          },
          error: (error) => this.toaster.error(error),
        });
    } else {
      this._wishlistService.deleteWishList(this.data.wishlist.id).subscribe({
        next: (response: any) => {
          if (!response.error) {
            this._dialogRef.close();
            const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `Deleted Data '${this.data.wishlist.name} sucessfully`,
                subHeading: `Check existing wishlists in My Wishlist page`,
                buttonValue: 'Finish',
              },
            });
          }
        },
        error: (error) => this.toaster.error(error),
      });
    }
  }
  fetchReacWishlistData() {
    this.isLoading = true;
    this._wishlistService
      .fetchReachUserWishlist(this.data.wishlist.id)
      .subscribe({
        next: (response: ReachUserWishlistRes) => {
          this.reachUserWishlists = response.data;

          if (this.reachUserWishlists.length == 0)
            this.toaster.success('No data found');
          this.isLoading = false;
        },
        error: (error) => this.toaster.error(error),
      });
  }
  onCellClick(event: any) {
    this._wishlistService.deleteDataInWishList(event.id).subscribe({
      next: (response: any) => {
        if (!response.error)
          this.dialog.open(DpSuccessMessageComponent, {
            panelClass: 'common-pannel-dialog-container',
            data: {
              mainHeading: `Deleted member data from wishlist`,
              subHeading: `Your can access all wish-lists from the My Wishlist menu on the Reach Defaulter page `,
              buttonValue: 'Finish',
            },
          });
      },
      error: (error) => {
        this.toaster.error(error);
      },
    });
    this._dialogRef.close(true);
  }
}
